<div class="message-button-intent">
    <div class="text" *ngIf="elements.payload.text.length > 0">{{ elements.payload.text[0] }}</div>
    <div class="button-group">
        <ng-container *ngFor="let item of elements.payload.items">
            <button class="button" (click)="addMessage(item)">{{ item.text }}</button>
        </ng-container>
    </div>
</div>